// export const API_HOST = "http://localhost:8085";
// export const API_HOST = "http://ec2-18-213-17-167.compute-1.amazonaws.com:8085";
export const API_HOST = "https://backend.microloanmalaysia.com";
